// Aim-gating: reveals the whale when the camera points within the configured
// horizontal threshold of the whale's position.
// Runs as an XR8 pipeline module so the check happens every AR frame.

import * as THREE from 'three';
import { getState, whaleRevealed } from '../state/appState';
import { getWhaleObject } from './whaleLoader';
import { startWhaleAnimation } from './whaleAnimation';
import { horizontalAngleDeg } from '../utils/math';
import { startStabilizationWindow } from './whalePlacement';
import { appConfig } from '../config/appConfig';
import { logger } from '../utils/logger';

type XR8Threejs = { Threejs: { xrScene(): { camera: THREE.Camera } } };

export function whaleRevealPipelineModule(): XR8PipelineModule {
  let camera: THREE.Camera | null = null;

  return {
    name: 'whale-reveal',

    onStart: () => {
      camera = (XR8 as unknown as XR8Threejs).Threejs.xrScene().camera;
    },

    onUpdate: () => {
      if (getState() !== 'ANCHORED_AWAITING_AIM') return;

      const whale = getWhaleObject();
      if (!whale || !camera) return;

      // Camera forward in world space (-Z local → world).
      const camForward = new THREE.Vector3();
      camera.getWorldDirection(camForward);

      // Horizontal vector from camera to whale.
      const toWhale = whale.position.clone().sub(camera.position);

      const angle = horizontalAngleDeg(camForward, toWhale);

      if (angle <= appConfig.aimThresholdDeg) {
        logger.log(`Aim threshold met (${angle.toFixed(1)}°) — revealing whale`);
        whale.visible = true;
        startStabilizationWindow();
        startWhaleAnimation();
        whaleRevealed();
      }
    },
  };
}
